module.exports = __webpack_public_path__ + "img/milli-gold.a92164f.png";